export function initMagellanModules() {
    const magellanModule = $('[data-magellan]');

    //Find magellan module on the page
    if (magellanModule.length > 0) {
        //Look for all elements with lazy loading enabled.
        const lozadElems = document.querySelectorAll('.lozad');

        /*Get array of lazy load capable elements, listen when the element is lazy loaded and 
        trigger page reflow to adjust magellan highlighting for updated distance to the top of target element*/
        Array.from(lozadElems).forEach( elem => {elem.addEventListener('load', function(){
            $('[data-magellan]').foundation('reflow');
        })});
    }
}
window.initMagellanModules = initMagellanModules;